<mat-icon *ngIf="icon" class="mr-5" [ngClass]="{ disabled: disabled }">{{ icon }}</mat-icon>
<span class="smart-alert-button"
      [ngClass]="{ disabled: disabled }"><ng-content></ng-content></span>
